import WorkingHours from './working-hours';

export default WorkingHours;
